export const uk = {
    'accept-button': 'Повысить',
    'many-days-title-hint':
        'Рекомендация показывается, потому что за последние {daysNumber} дней кампании останавливались из‑за ограничений дневного бюджета и теряли эффективные клики',
    'one-day-title-hint':
        'Рекомендация показывается, потому что за последний день кампании останавливались из‑за ограничений дневного бюджета и теряли эффективные клики',
    'simple-progress-hint': 'Повышаем ограничение бюджета',
    'simple-title': 'Повысьте ограничение бюджета до {sum}',
    'some-days-title-hint':
        'Рекомендация показывается, потому что за последние {daysNumber} дня кампании останавливались из‑за ограничений дневного бюджета и теряли эффективные клики'
};
